import { ChatMessage, ChatMessageApi } from "../../types";
import { jsonSerializer } from "./jsonSerializer";

export const chatMessageSerializer = jsonSerializer(
  (data: ChatMessageApi): ChatMessage => ({
    role: "assistant",
    content: data.answer,
    id: data.question_id,
    creation_timestamp: data.question_timestamp,
    isTruncated: data.is_truncated,
    error: false,
  }),
);
